/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含日期信息的JSON对象
 */
export type PostMiscDateDiffRequest = {
  start_date: string;
  end_date: string;
  format?: string | undefined;
};

export const PostMiscDateDiffRequest$zodSchema: z.ZodType<
  PostMiscDateDiffRequest
> = z.object({
  end_date: z.string(),
  format: z.string().optional(),
  start_date: z.string(),
}).describe("包含日期信息的JSON对象");

/**
 * 日期解析失败或参数错误
 */
export type PostMiscDateDiffBadRequestResponseBody = {
  error_code?: string | undefined;
  error_message?: string | undefined;
  error_details?: string | undefined;
};

export const PostMiscDateDiffBadRequestResponseBody$zodSchema: z.ZodType<
  PostMiscDateDiffBadRequestResponseBody
> = z.object({
  error_code: z.string().optional(),
  error_details: z.string().optional(),
  error_message: z.string().optional(),
}).describe("日期解析失败或参数错误");

/**
 * 计算成功，返回多种单位的时间差值
 */
export type PostMiscDateDiffResponseBody = {
  days?: number | undefined;
  hours?: number | undefined;
  minutes?: number | undefined;
  seconds?: number | undefined;
  weeks?: number | undefined;
  human_readable?: string | undefined;
};

export const PostMiscDateDiffResponseBody$zodSchema: z.ZodType<
  PostMiscDateDiffResponseBody
> = z.object({
  days: z.int().optional(),
  hours: z.int().optional(),
  human_readable: z.string().optional(),
  minutes: z.int().optional(),
  seconds: z.int().optional(),
  weeks: z.int().optional(),
}).describe("计算成功，返回多种单位的时间差值");

export type PostMiscDateDiffResponse =
  | PostMiscDateDiffResponseBody
  | PostMiscDateDiffBadRequestResponseBody;

export const PostMiscDateDiffResponse$zodSchema: z.ZodType<
  PostMiscDateDiffResponse
> = z.union([
  z.lazy(() => PostMiscDateDiffResponseBody$zodSchema),
  z.lazy(() => PostMiscDateDiffBadRequestResponseBody$zodSchema),
]);
